import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Grid, GridItem } from '../../helpers';
import ImageWithCaption from '../../components/Image/ImageWithCaption';
import { mixins } from '../../core/styles/theme/default';
import { ImageInterface } from '~/types';

const StyledGrid = styled(Grid)(
  ({ isAlignedLeft }: { isAlignedLeft: boolean }) => css`
    align-items: center;

    ${!isAlignedLeft &&
    css`
      flex-direction: row-reverse;
    `}
  `,
);

const StyledImage = styled(ImageWithCaption)(css`
  text-align: center;

  ${mixins.responsiveStyles({
    'margin-bottom': {
      zero: 24,
      medium: 0,
    },
  })}
`);

const ImageTextBlock = ({
  image,
  richtext,
  isAlignedLeft = true,
}: ImageTextBlockProps) => (
  <div className="m-imagetextblock">
    <StyledGrid isAlignedLeft={isAlignedLeft} columns={12}>
      <GridItem size={{ zero: 12, medium: 6 }}>
        <StyledImage data={image} />
      </GridItem>
      <GridItem size={{ zero: 12, medium: 6 }}>{richtext}</GridItem>
    </StyledGrid>
  </div>
);

export type ImageTextBlockProps = {
  image: ImageInterface;
  richtext: ReactNode;
  isAlignedLeft?: boolean;
};

export default ImageTextBlock;
